/**
 * Build folderMappingsStorage seeds so Data Storage breadcrumbs match a normal drill-down:
 * Home / <root display> / <segment> / … for each path level under the browse root.
 */
export function buildDataStorageFolderMappingSeed(
  rootDisplayName: string,
  rootPrefix: string,
  leafPrefix: string,
): Array<[string, string]> {
  const rp = rootPrefix.replace(/\/+$/, "");
  const lp = leafPrefix.replace(/\/+$/, "");
  const pairs: Array<[string, string]> = [[rootDisplayName, rp]];
  if (!lp || lp === rp) {
    return pairs;
  }
  if (!lp.startsWith(`${rp}/`)) {
    const segs = lp.split("/").filter(Boolean);
    const leafSeg = segs.length ? (segs[segs.length - 1] ?? "") : "";
    if (leafSeg) {
      pairs.push([leafSeg, lp]);
    }
    return pairs;
  }
  let accum = rp;
  const rest = lp.slice(rp.length + 1);
  for (const seg of rest.split("/").filter(Boolean)) {
    accum = `${accum}/${seg}`;
    pairs.push([seg, accum]);
  }
  return pairs;
}
